import { Auth } from 'aws-amplify';
import awsConfig from '../aws-exports';

const endpoint = 'https://dvrdlzjhma.execute-api.us-east-1.amazonaws.com/membership';
const enabled = awsConfig.aws_user_pools_id === 'us-east-1_e3UZsMOQP'
  && awsConfig.aws_user_pools_web_client_id === '3agg9qbud45bipf6a5cspm2g3k';
const pending = new Map();

export const storeAccessApi = {
  get(userID) {
    if (!userID || !enabled) return Promise.resolve(null);
    if (pending.has(userID)) return pending.get(userID);
    const work = (async () => {
      const session = await Auth.currentSession();
      const token = session.getIdToken();
      if (token.payload.sub !== userID) throw new Error('Your account changed. Refresh membership.');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(endpoint, { headers: { Authorization: `Bearer ${token.getJwtToken()}` }, cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Store membership could not be verified. Please retry.');
        const data = await response.json();
        if (data.source !== 'app_store' || typeof data.active !== 'boolean'
          || (data.active && !Number.isFinite(Date.parse(data.expiresAt)))) throw new Error('Invalid membership response. Please retry.');
        const current = await Auth.currentSession();
        if (current.getIdToken().payload.sub !== userID) throw new Error('Your account changed. Refresh membership.');
        return data;
      } finally { clearTimeout(timeout); }
    })();
    pending.set(userID, work);
    work.then(() => { if (pending.get(userID) === work) pending.delete(userID); }, () => { if (pending.get(userID) === work) pending.delete(userID); });
    return work;
  },
};
